// extracted by mini-css-extract-plugin
export var body = "_ew-8";
export var button = "_ew-0";
export var closeButton = "_ew-5";
export var content = "_ew-3";
export var empty = "_ew-f";
export var grid = "_ew-c";
export var header = "_ew-4";
export var icon = "_ew-1";
export var option = "_ew-d";
export var optionSelected = "_ew-e";
export var overlay = "_ew-2";
export var searchIcon = "_ew-a";
export var searchInput = "_ew-b";
export var searchWrapper = "_ew-9";
export var title = "_ew-6";
export var visuallyHidden = "_ew-7";